module.exports = {
  primary: '#6ee6d2',
  secondary: '#ff995e',
  white: '#fcfcfc',
  grey: '#f2f2f2',
  darkGrey: '#828282',
  black: '#282828',
}
